const CUTOFF_DATE = 'December 7'

// Placeholder copy pending final L&D approval. Edit strings here only.
export const RES_CENTER_MIGRATION_COPY = {
  cutoffDate: CUTOFF_DATE,
  banner: {
    title: 'Buzz is moving to Pay Ready ResCenter',
    body: `Starting ${CUTOFF_DATE}, your inbox and conversations will live in ResCenter. Buzz stays available until then so you can switch when you are ready.`,
    learnMore: 'Learn more',
    tryIt: 'Try ResCenter',
    sending: 'Sending...',
  },
  confirm: {
    title: 'Try ResCenter now?',
    body: `We will use your Buzz email to get you into ResCenter. If you are new to ResCenter, we will email you a link to set up your access. Buzz stays open and available until ${CUTOFF_DATE}.`,
    confirm: 'Continue',
    cancel: 'Cancel',
  },
  emailed: {
    title: 'Check your email to finish setting up ResCenter',
    body: `We sent a setup email to your Buzz email address. Open the newest email with subject "Welcome to Pay Ready!" and select the Set up your account button. If you do not see it, check your Spam folder. You can keep working in Buzz until ${CUTOFF_DATE}.`,
    forgotPassword: "Still can't find it? Reset your ResCenter password",
    alreadySent: `A ResCenter setup email was already sent to your Buzz email address. Open the newest email with subject "Welcome to Pay Ready!" and select the Set up your account button. If you do not see it, check your Spam folder. You can keep working in Buzz until ${CUTOFF_DATE}.`,
  },
  learnMoreError:
    'The help article opened, but we could not save that you viewed it. Click Learn more again to unlock Try ResCenter.',
  errors: {
    processing:
      'Your ResCenter access is still being set up. Try again in a minute.',
    existing_user_unprovisioned:
      'Your ResCenter access is not ready yet. Contact support to finish setting it up.',
    company_id_required:
      'We could not confirm which company your account belongs to. Contact support to continue.',
    company_mismatch:
      'Your Buzz account does not match the company on your ResCenter access. Contact support to continue.',
    debtor_user:
      'This email belongs to a resident account and cannot be used for ResCenter staff access. Contact support to continue.',
    missing_rescenter_role:
      'Your account does not have ResCenter access yet. Contact support to have it added.',
    missing_email:
      'We could not find an email address on your Buzz profile. Contact support to continue.',
    delivery_failed:
      'We could not deliver the email. Check your address with support or try again.',
    delivery_unconfirmed:
      'Your invitation may have been delivered, but we could not confirm it. Please do not keep retrying, because another invitation could invalidate the newest reset link. Check your newest email, or contact support if it does not arrive.',
    not_found:
      'We could not find your ResCenter access. Contact support to continue.',
    unavailable:
      'ResCenter access is not available right now. Try again later.',
    generic: 'Something went wrong. Please try again.',
  },
} as const

export type ResCenterMigrationErrorKey =
  keyof typeof RES_CENTER_MIGRATION_COPY.errors
